import { WorkflowDetailsState } from "@idw-types/state/workflow-details-state";
import { getWorkflowDetailsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getWorkflowDetailsAdvancedWorkflowDetailsState = createSelector(getWorkflowDetailsState, (state: WorkflowDetailsState) => {
	return state.advancedWorkflowDetails;
});